import {
  AboutYouKnob,
  AboutYouLogoText,
  COLORS,
  FONT_SIZES,
  Text,
  desktopAndUp,
} from '@aboutyou/ui-components';
import {useUserFirstName} from '@aboutyou/user';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

export const FashionUpdateTitle: FC<{
  headline: string;
  className?: string;
}> = ({headline, className}) => {
  const userFirstName = useUserFirstName();

  return (
    <TitleWrapper className={className}>
      <AboutYouWrapper>
        <StyledAboutYouLogoText>ABOUT</StyledAboutYouLogoText>
        <AboutYouUserText>
          {userFirstName} <StyledAboutYouKnob color="Black" />
        </AboutYouUserText>
      </AboutYouWrapper>
      <Text color="YellowGold" size="px24" weight="bold">
        {headline}
      </Text>
    </TitleWrapper>
  );
};

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  row-gap: 0.5rem;
  column-gap: 1rem;
  justify-content: center;
  flex-direction: column;

  ${desktopAndUp(css`
    flex-direction: row;
  `)}
`;

const StylesAboutYouLogoText = css`
  background-color: ${COLORS.YellowGold};
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px24};
`;

const StyledAboutYouLogoText = styled(AboutYouLogoText)`
  ${StylesAboutYouLogoText}
  border-radius: 3px 0 0 3px;
`;

const AboutYouUserText = styled(AboutYouLogoText)`
  ${StylesAboutYouLogoText}
  border-radius: 0 3px 3px 0;
  margin-left: 4px;
  padding-right: 1.3rem;
  position: relative;
`;

const StyledAboutYouKnob = styled(AboutYouKnob)`
  position: absolute;
  right: 4px;
  top: 5px;
`;

const AboutYouWrapper = styled.div`
  display: flex;
`;
